import { render, staticRenderFns } from "./RelatoriosDeExportacao.vue?vue&type=template&id=ac261060&scoped=true"
import script from "./RelatoriosDeExportacao.vue?vue&type=script&lang=js"
export * from "./RelatoriosDeExportacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac261060",
  null
  
)

export default component.exports